import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { 
  BsHouseDoor, 
  BsChevronRight, 
  BsCalendar4, 
  BsGraphUp, 
  BsFileText, 
  BsBarChart, 
  BsBullseye, 
  BsCheckCircle, 
  BsClock,
  BsArrowUpShort,
  BsArrowRightShort,
  BsDash
} from 'react-icons/bs';
import './style.css';

const Dashboard = () => {
  const hedefTamamlanmaOptions = {
    chart: {
      type: 'pie',
      height: '280px',
      backgroundColor: 'transparent',
      style: {
        fontFamily: "'Inter', sans-serif"
      }
    },
    title: {
      text: 'Hedef Tamamlanma Durumu',
      style: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#2c3e50'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        borderWidth: 2,
        borderColor: '#fff',
        innerSize: '60%',
        dataLabels: {
          enabled: true,
          format: '{point.name}: {point.percentage:.1f}%',
          style: {
            fontSize: '12px'
          }
        }
      }
    },
    series: [{
      name: 'Hedefler',
      data: [
        { name: 'Tamamlanan', y: 60, color: '#10B981' },
        { name: 'Devam Eden', y: 30, color: '#3B82F6' },
        { name: 'Geciken', y: 10, color: '#EF4444' }
      ]
    }],
    credits: {
      enabled: false
    }
  };

  const performansGrafigiOptions = {
    chart: {
      type: 'column',
      height: '280px',
      backgroundColor: 'transparent',
      style: {
        fontFamily: "'Inter', sans-serif"
      }
    },
    title: {
      text: 'Birim Performans Göstergeleri',
      style: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#2c3e50'
      }
    },
    xAxis: {
      categories: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs'],
      labels: {
        style: {
          fontSize: '12px'
        }
      }
    },
    yAxis: {
      title: {
        text: 'Tamamlanma Yüzdesi',
        style: {
          fontSize: '12px'
        }
      },
      labels: {
        format: '{value}%',
        style: {
          fontSize: '12px'
        }
      }
    },
    plotOptions: {
      column: {
        borderRadius: 5,
        borderWidth: 0,
        gradient: {
          enabled: true
        }
      }
    },
    series: [{
      name: 'Hedef',
      data: [80, 85, 90, 88, 92],
      color: {
        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
        stops: [
          [0, '#3B82F6'],
          [1, '#60A5FA']
        ]
      }
    }],
    credits: {
      enabled: false
    }
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="dashboard-header-top">
          <div className="dashboard-header-left">
            <div className="dashboard-welcome-section">
              <div className="dashboard-welcome-text">
                <span className="dashboard-greeting">Dekan</span>
                <h1>Prof. Dr. Lorem Ipsum</h1>
                <p className="dashboard-role">Dekan <span className="dashboard-department">Mühendislik Fakültesi</span></p>
              </div>
              <p className="dashboard-welcome-description">
                Hedef izleme sistemine hoş geldiniz. Güncel performans ve hedeflerinizi buradan takip edebilirsiniz.
              </p>
            </div>
            <div className="dashboard-stats">
              <div className="dashboard-stat-item">
                <div className="dashboard-stat-icon">
                  <BsBullseye />
                </div>
                <div className="dashboard-stat-info">
                  <span className="dashboard-stat-label">Dönem</span>
                  <span className="dashboard-stat-value">2023-2024</span>
                </div>
              </div>
              <div className="dashboard-stat-item">
                <div className="dashboard-stat-icon">
                  <BsGraphUp />
                </div>
                <div className="dashboard-stat-info">
                  <span className="dashboard-stat-label">Aktif Hedef</span>
                  <span className="dashboard-stat-value">12/24</span>
                </div>
              </div>
              <div className="dashboard-stat-item">
                <div className="dashboard-stat-icon success">
                  <BsCheckCircle />
                </div>
                <div className="dashboard-stat-info">
                  <span className="dashboard-stat-label">Başarı Oranı</span>
                  <span className="dashboard-stat-value success">%85</span>
                </div>
              </div>
            </div>
          </div>
          <div className="dashboard-header-right">
            <div className="dashboard-quick-actions">
              <button className="dashboard-action-btn primary">
                <BsBullseye />
                <span>Yeni Hedef</span>
              </button>
              <button className="dashboard-action-btn secondary">
                <BsFileText />
                <span>Rapor Oluştur</span>
              </button>
              <button className="dashboard-action-btn outline">
                <BsGraphUp />
                <span>Detaylı Analiz</span>
              </button>
            </div>
          </div>
        </div>
        <div className="dashboard-header-bottom">
          <div className="dashboard-nav">
            <div className="dashboard-nav-item active">
              <BsHouseDoor />
              <span>Genel Bakış</span>
            </div>
            <div className="dashboard-nav-item">
              <BsBullseye />
              <span>Hedefler</span>
              <span className="dashboard-nav-badge">8</span>
            </div>
            <div className="dashboard-nav-item">
              <BsGraphUp />
              <span>Performans</span>
            </div>
            <div className="dashboard-nav-item">
              <BsFileText />
              <span>Raporlar</span>
            </div>
          </div>
          <div className="dashboard-period-selector">
            <span className="dashboard-period-label">Dönem:</span>
            <select className="dashboard-period-select">
              <option>2023-2024 Bahar</option>
              <option>2023-2024 Güz</option>
              <option>2022-2023 Bahar</option>
            </select>
          </div>
        </div>
      </div>

      <div className="dashboard-summary-cards">
        <div className="dashboard-stat-card">
          <div className="dashboard-stat-card-header">
            <div className="dashboard-stat-card-icon blue">
              <BsBullseye size={20} />
            </div>
            <div className="dashboard-stat-card-trend positive">
              <BsArrowUpShort size={20} />
              <span>8%</span>
            </div>
          </div>
          <div className="dashboard-stat-card-content">
            <h3>Toplam Hedef</h3>
            <p className="number">24</p>
            <div className="dashboard-stat-card-footer">
              <span>Detay</span>
              <BsArrowRightShort size={20} />
            </div>
          </div>
        </div>

        <div className="dashboard-stat-card">
          <div className="dashboard-stat-card-header">
            <div className="dashboard-stat-card-icon green">
              <BsCheckCircle size={20} />
            </div>
            <div className="dashboard-stat-card-trend positive">
              <BsArrowUpShort size={20} />
              <span>12%</span>
            </div>
          </div>
          <div className="dashboard-stat-card-content">
            <h3>Tamamlanan</h3>
            <p className="number">16</p>
            <div className="dashboard-stat-card-footer">
              <span>Detay</span>
              <BsArrowRightShort size={20} />
            </div>
          </div>
        </div>

        <div className="dashboard-stat-card">
          <div className="dashboard-stat-card-header">
            <div className="dashboard-stat-card-icon purple">
              <BsGraphUp size={20} />
            </div>
            <div className="dashboard-stat-card-trend neutral">
              <BsDash size={20} />
              <span>0%</span>
            </div>
          </div>
          <div className="dashboard-stat-card-content">
            <h3>Aktif Projeler</h3>
            <p className="number">8</p>
            <div className="dashboard-stat-card-footer">
              <span>Detay</span>
              <BsArrowRightShort size={20} />
            </div>
          </div>
        </div>

        <div className="dashboard-stat-card">
          <div className="dashboard-stat-card-header">
            <div className="dashboard-stat-card-icon orange">
              <BsFileText size={20} />
            </div>
            <div className="dashboard-stat-card-trend positive">
              <BsArrowUpShort size={20} />
              <span>15%</span>
            </div>
          </div>
          <div className="dashboard-stat-card-content">
            <h3>Yayınlar</h3>
            <p className="number">32</p>
            <div className="dashboard-stat-card-footer">
              <span>Detay</span>
              <BsArrowRightShort size={20} />
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard-charts-container">
        <div className="dashboard-chart-card">
          <div className="dashboard-chart-card-header">
            <h3>Hedef Tamamlanma Durumu</h3>
            <div className="dashboard-chart-card-actions">
              <button className="dashboard-chart-period-btn active">Aylık</button>
              <button className="dashboard-chart-period-btn">Yıllık</button>
            </div>
          </div>
          <HighchartsReact highcharts={Highcharts} options={hedefTamamlanmaOptions} />
        </div>
        <div className="dashboard-chart-card">
          <div className="dashboard-chart-card-header">
            <h3>Birim Performans Göstergeleri</h3>
            <div className="dashboard-chart-card-actions">
              <button className="dashboard-chart-period-btn active">Aylık</button>
              <button className="dashboard-chart-period-btn">Yıllık</button>
            </div>
          </div>
          <HighchartsReact highcharts={Highcharts} options={performansGrafigiOptions} />
        </div>
      </div>

      <div className="dashboard-bottom-section">
        <div className="dashboard-activities-card">
          <div className="dashboard-card-header">
            <h2>
              <BsClock />
              Son Aktiviteler
            </h2>
            <button className="dashboard-view-all-btn">Tümünü Gör</button>
          </div>
          <div className="dashboard-activity-list">
            <div className="dashboard-activity-item">
              <div className="dashboard-activity-icon green">
                <BsCheckCircle />
              </div>
              <div className="dashboard-activity-content">
                <h4>Yeni Yayın Eklendi</h4>
                <p>Lorem Ipsum Aqua'da yeni makale yayınlandı</p>
                <span className="dashboard-activity-time">2 saat önce</span>
              </div>
            </div>
            <div className="dashboard-activity-item">
              <div className="dashboard-activity-icon blue">
                <BsGraphUp />
              </div>
              <div className="dashboard-activity-content">
                <h4>Hedef Güncellendi</h4>
                <p>Lorem Ipsum Aqua projesi başlatıldı</p>
                <span className="dashboard-activity-time">5 saat önce</span>
              </div>
            </div>
            <div className="dashboard-activity-item">
              <div className="dashboard-activity-icon orange">
                <BsBullseye />
              </div>
              <div className="dashboard-activity-content">
                <h4>Yeni Proje Başlatıldı</h4>
                <p>TÜBİTAK 1001 projesi başlatıldı</p>
                <span className="dashboard-activity-time">1 gün önce</span>
              </div>
            </div>
          </div>
        </div>

        <div className="dashboard-upcoming-card">
          <div className="dashboard-card-header">
            <h2>
              <BsCalendar4 />
              Yaklaşan Hedef Tarihleri
            </h2>
            <button className="dashboard-view-all-btn">Tümünü Gör</button>
          </div>
          <div className="dashboard-upcoming-list">
            <div className="dashboard-upcoming-item">
              <div className="dashboard-date">
                <span className="day">15</span>
                <span className="month">Oca</span>
              </div>
              <div className="dashboard-upcoming-content">
                <div className="dashboard-upcoming-header">
                  <h4>Q4 Değerlendirme Raporu</h4>
                  <span className="status-badge success"></span>
                </div>
                <p>Birim performans değerlendirme raporunun tamamlanması</p>
                <div className="progress">
                  <div className="progress-bar" style={{ width: '80%' }}></div>
                  <span>%80</span>
                </div>
              </div>
            </div>
            <div className="dashboard-upcoming-item">
              <div className="dashboard-date">
                <span className="day">22</span>
                <span className="month">Oca</span>
              </div>
              <div className="dashboard-upcoming-content">
                <div className="dashboard-upcoming-header">
                  <h4>Proje Ara Raporu</h4>
                  <span className="status-badge warning"></span>
                </div>
                <p>TÜBİTAK 1001 projesi ara rapor teslimi</p>
                <div className="progress">
                  <div className="progress-bar warning" style={{ width: '65%' }}></div>
                  <span>%65</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 